export const COGNITO_LOGIN_CALLBACK_ROUTE = '/authentication/callback'
export const COGNITO_LOGOUT_CALLBACK_ROUTE = '/logout/callback'
export const COGNITO_ROUTES = [
  COGNITO_LOGIN_CALLBACK_ROUTE,
  COGNITO_LOGOUT_CALLBACK_ROUTE
]
